<div [style.position]="'relative'" [style.cursor]="showingSIN ? 'pointer' : 'not-allowed'">
  <input
    *ngIf="!showMaskedSIN"
    class="sin-input"
    type="text"
    inputmode="text"
    autocomplete="off"
    [attr.id]="controlId"
    [maskito]="maskOptions"
    [value]="value"
    [disabled]="disabled"
    [class.review-input-error-border]="error"
    (input)="handleInput($event)"
    (blur)="handleBlur()" />

  <div
    #hiddenSIN
    [hidden]="!showMaskedSIN"
    class="sin-input sin-input-hidden"
    [attr.contenteditable]="false"
    [class.review-input-error-border]="error"
    [class.disabled]="disabled"
    [ngStyle]="{ 'padding-right': showHideSINButton ? '2rem' : '0' }"></div>
  <button
    class="eye"
    (click)="toggleShowHide()"
    [disabled]="!canRevealSIN"
    type="button"
    aria-label="Show or hide SIN"
    i18n-aria-label
    [ngClass]="{
      opened: !showMaskedSIN,
      closed: showMaskedSIN,
      error: error,
      disabled: !canRevealSIN
    }"></button>
</div>
